export const contractItemTypeToApi = {
  SERVICE: "services",
  MATERIAL: "materials",
  ACCESSORY: "accessories",
  ADDON: "addons",
  SUPPLEMENT: "supplements",
  SERVICEPACKAGE: "servicepackages"
} as const;
